import { CurrencyMap } from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';
import { z } from 'zod';

const CurrencyTypes = Object.keys(CurrencyMap.codes) as Array<
  keyof typeof CurrencyMap.codes
>;

export const CandidateCompensationSchema = z.object({
  id: z.string().uuid(),
  baseAnnualSalary: z.number().nonnegative().nullable(),
  compensation: z.string().nullable(),
  hourlyCompensation: z.string().nullable(),
  compHourlyPremium: z.number().nonnegative().nullable(),
  currencyType: z.enum(ZodArrayToEnum(CurrencyTypes)).nullable(),
});

export type CandidateCompensation = z.infer<typeof CandidateCompensationSchema>;
